import { MAX_RESULTS } from '../constants';

export default function getViewAllIndex(emojiResults: string[]) {
    return Math.min(emojiResults.length, MAX_RESULTS);
}
